import React, { useState } from "react";
import { Modal, Form, Row, Col, Button, Table, message } from 'antd';
import { config } from "util/config";
import { httpClient } from 'util/Api';
import { useHistory } from "react-router-dom";
import * as globalFunction from 'util/GlobalFunction';
import AppNotificationContainer from 'components/AppNotificationContainer';
import PaymentHeader from '../Header';

const Quote = () => {
  const history = useHistory();
  let pathname = window.location.pathname.split('/');

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <QuotePage quoteId={pathname[pathname.length - 1]} history={history} urlParams={urlParams} />
  )
}
export default Quote;

class QuotePage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      quote: null,
      submitting: false,
    }
  }

  componentDidMount() {
    let isApproved = null;
    switch (this.props.urlParams.get('is_approved')) {
      case 'true': isApproved = true; break;
      case 'false': isApproved = false; break;
    }
    this.setState({ isApproved, message: this.props.urlParams.get('message') });
    this.getQuote();
  }

  getQuote() {
    httpClient
      .get('/PublicPayment/NAB/GetQuote/' + this.props.quoteId)
      .then(({ data }) => {
        if (data.result) {
          // console.log(data.data);
          this.setState({ quote: data.data });
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, this);
      });
  }

  render() {
    return (
      <>
        {
          this.state.quote !== null ?
            <div>
              <div className='public-payment-div' style={{ padding: '20px' }}>
                <Row gutter={config.component.gutter}>
                  <PaymentHeader job={this.state.quote.Job} />
                  <Col span={24} style={{ marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Quote {this.state.quote.QuoteNumber}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Date:</span> {globalFunction.truncateString(this.state.quote.Date, 10)}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Expiry Date:</span> {globalFunction.truncateString(this.state.quote.ExpiryDate, 10)}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Quote To:</span> {this.state.quote.Job.Applicant?.FullNameCompany}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Job No.:</span> {this.state.quote.Job.JobNum}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Work Description:</span> {this.state.quote.Job.WorkDescription}</span>
                  </Col>
                  <Col span={24} style={{ marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Quote Details</span>
                  </Col>
                  <Col span={24}>
                    <Table
                      bordered
                      className='vertical-align-top-table'
                      pagination={false}
                      size="small"
                      dataSource={this.state.quote.QuoteLineItemList}
                      columns={[
                        {
                          title: 'Description',
                          dataIndex: 'Description',
                        },
                        {
                          title: 'Qty',
                          dataIndex: 'Quantity',
                        },
                        {
                          title: 'Unit Amount',
                          dataIndex: 'DiscountUnitAmount',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        },
                        {
                          title: 'GST',
                          dataIndex: 'TaxAmount',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        },
                        {
                          title: 'Amount',
                          dataIndex: 'Total',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        }
                      ]}
                    />
                  </Col>
                  <Col span={24} style={{ textAlign: 'center', marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Quote Total: {globalFunction.formatMoney(this.state.quote.Total)}</span>
                  </Col>
                  <Col span={24} style={{ textAlign: 'center', marginTop: '10px' }}>
                    <Button type="primary"
                      style={{ width: '30%', minWidth: '200px' }}
                      loading={this.state.submitting}
                      disabled={this.state.submitting}
                      onClick={() => {
                        const total = Math.round(this.state.quote.Total * 100); // 转换为总分数
                        const dollar = Math.floor(total / 100);      // 元
                        const cents = total % 100;
                        window.location.href = 'https://demo.paybyweb.nab.com.au/SecureBillPayment/start?org_id=ba1&bill_name=quote&primary_ref=' + this.state.quote.QuoteNumber + ' (ref: ' + this.state.invoice.EncryptedQuoteId + ')'
                          + '&secondary_ref=' + this.state.quote.Job.JobNum
                          + '&dollar_amount=' + String(dollar).padStart(2, "0")
                          + '&cents_amount=' + String(cents).padStart(2, "0");
                      }}>
                      Pay Now
                    </Button>
                  </Col>
                </Row>
                <div id="embed-target" style={{ marginTop: '10px' }}></div>
              </div>
            </div> : <AppNotificationContainer loading={this.state.quote == null} error={''} />
        }
      </>
    );
  }
};
